<template>
  <v-container
    class="ma-0 pa-0 white lighten-4"
    fluid
    fill-height
  >
    <v-layout>
      <v-flex>
        <fullpage-loader
          message="טוען פרטי אירוע..."
          v-if="!event"
        ></fullpage-loader>

        <table
          class="ma-3"
          v-else
        >
          <tr
            v-for="(header, index) in headers"
            v-if="event[header.value]"
          >
            <td class="font-weight-bold header-col">{{ header.text }}</td>
            <td>{{ header.displayFunc(event, header.value) }}</td>
          </tr>
        </table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { format } from "date-fns";
import FullpageLoader from "../../FullpageLoader.vue";
export default {
  data() {
    return {
      headers: [
        {
          text: "זמן התחלה",
          value: "startDate",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            return format(data[key], "DD-MM-YYYY HH:mm");
          }
        },
        {
          text: "זמן סיום",
          value: "endDate",
          align: "right",
          displayFunc: (data, key) => {
            return data[key]
              ? format(data[key], "DD-MM-YYYY HH:mm")
              : "אירוע פעיל";
          }
        },
        {
          text: "תיאור",
          value: "description",
          align: "right",
          displayFunc: (data, key) => {
            return data[key];
          }
        },
        {
          text: "סוג",
          value: "type",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            let eventType = this.entityById(
              "eventTypes",
              data[key] ? data[key]._id : data[key]
            );
            return eventType ? eventType["title"] : "ללא סוג";
          }
        },
        {
          text: "תת סוג",
          value: "subType",
          align: "right",
          displayFunc: (data, key) => {
            let eventSubType = this.entityById(
              "eventSubTypes",
              data[key] ? data[key]._id : data[key]
            );
            return eventSubType ? eventSubType["title"] : "ללא תת סוג";
          }
        },
        {
          text: "מקור",
          value: "source",
          align: "right",
          displayFunc: (data, key) => {
            let eventSource = this.entityById(
              "eventSources",
              data[key] ? data[key]._id : data[key]
            );
            return eventSource ? eventSource["title"] : "ללא מקור";
          }
        },
        {
          text: "אופן פינוי",
          value: "evacuationType",
          align: "right",
          displayFunc: (data, key) => {
            let evacuationType = this.entityById(
              "evacuationTypes",
              data[key] ? data[key]._id : data[key]
            );
            return evacuationType ? evacuationType["title"] : "לא ידוע";
          }
        },
        {
          text: "מדינות",
          value: "countries",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            let field = "name";
            let p = {};
            let array = data[key];
            if (Array.isArray(array) && array.length) {
              return array
                .map(item => {
                  let country = this.entityById("countries", item ? item._id || item : null);
                  return country ? country[field] : "ללא";
                })
                .reduce((p, v) => p + ", " + v);
            }
            return "";
          }
        },
        {
          text: "איזורים",
          value: "regions",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            let field = "name";
            let p = {};
            let array = data[key];
            if (Array.isArray(array) && array.length) {
              return array
                .map(item => {
                  let region = this.entityById("regions", item._id || item);
                  return region ? region[field] : "ללא שם";
                })
                .reduce((p, v) => p + ", " + v);
            }
            return "כל האיזורים";
          }
        },
        {
          text: "דו״חות הראל",
          value: "includedInHarelReports",
          align: "right",
          displayFunc: (data, key) => {
            return data[key] ? "כן" : "לא";
          }
        },
        
        {
          text: "תחקיר",
          value: "debriefing",
          align: "right",
          displayFunc: (data, key) => {
            return data[key] ? "כן" : "לא";
          }
        },
      ]
    };
  },

  computed: {
    event() {
      return this.$store.state.entities.events[this.eventId];
    }
  },

  methods: {
    format,
    envokeMethodByName(name) {
      this[name]();
    },
    entityById(entityType, id) {
      return this.$store.getters["entity"](entityType, id);
    }
  },

  components: {
    FullpageLoader
  },

  props: ["eventId"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

td {
  padding-bottom: 10px;
  vertical-align: top;
}

.header-col {
  min-width: 120px;
}

</style>


// WEBPACK FOOTER //
// src/components/events/modules/EventDetails.vue